import React, { useState, useEffect, useContext } from 'react'
import Swal from 'sweetalert2';
import { AcceptAgreement, getAcceptedAgreement, getAcceptedAgreements } from '../api/agreements'
import { AuthContext } from '../context/AuthContext';

export const useAgreements = () => {
    const { setLoading, checkToken } = useContext(AuthContext);
    const [agreements, setAgreements] = useState([]);

    const acceptAgreement = async (datos) => {
        checkToken()
        try {
            setLoading(true);
            let response = await AcceptAgreement(datos);
            setLoading(false);
            return true
        } catch (e) {
            setLoading(false);
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "Su solicitud no puede ser procesada",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            })
            return false;
        }
    }

    const AcceptedAgreements = async () => {
        checkToken()
        try {
            setLoading(true);
            const { data } = await getAcceptedAgreements()
            setAgreements(data.data)
            setLoading(false);
            return [true, data.data]
        } catch (error) {
            setLoading(false);
            console.log(error.response)
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "Su solicitud no puede ser procesada",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            })
            return [false]
        }
    }

    const AcceptedAgreemenById = async (id) => {
        checkToken()
        try {
            setLoading(true);
            const { data } = await getAcceptedAgreement(id)
            setLoading(false);
            return [true, data.data]
        } catch (error) {
            setLoading(false);
            console.log(error.response)
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "Su solicitud no puede ser procesada",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
            })
            return [false]
        }
    }


    // const acceptAgreement = async (datos) => {
    //     checkToken()
    //     try {
    //         setLoading(true);
    //         let response = await AcceptAgreement(datos);
    //         setLoading(false);
    //         return true
    //     } catch (e) {
    //         setLoading(false);
    //         Swal.fire({
    //             showCloseButton: true,
    //             title: 'Advertencia',
    //             text: "Su solicitud no puede ser procesada",
    //             icon: 'warning',
    //             showCancelButton: false,
    //             confirmButtonColor: '#fd6e0d',
    //             iconColor: "#fd6e0d",
    //             confirmButtonText: 'Entendido'
    //         })
    //         return false;
    //     }
    // }
    return {
        acceptAgreement,
        AcceptedAgreements,
        AcceptedAgreemenById,
        agreements
    }


}

